import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, BuildingIcon, TargetIcon, FileTextIcon, MailIcon } from '../icons/Icons';
import './BottomNav.css';

const BottomNav = () => {
  const navItems = [
    { path: '/', icon: HomeIcon, label: 'Home', exact: true },
    { path: '/about', icon: BuildingIcon, label: 'About' },
    { path: '/portfolio', icon: TargetIcon, label: 'Portfolio' },
    { path: '/blog', icon: FileTextIcon, label: 'Blog' },
    { path: '/contact', icon: MailIcon, label: 'Contact' }
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
          end={item.exact}
        >
          <item.icon size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
